import React, { forwardRef } from 'react';
import { Database, DatabaseZap } from 'lucide-react';
import SchemaDrawer from './SchemaDrawer';
import DataSourceDemoFlow from './DataSourceDemoFlow';

export interface DataCollectionMethodProps {
  dataCollectionOptions: any[];
  getColorClasses: (color: string) => string;
  getIconColor: (color: string, isDisabled?: boolean) => string;
  loading?: boolean;
  isSchemaDrawerOpen: boolean;
  openSchemaModal: () => void;
  openSchemaDrawer: () => void;
  closeAllModals: () => void;
  alreadyConfiguredSourceIds?: string[];
  forceReset?: boolean;
  connectionDraftKey?: number;
}

const DataCollectionMethod = forwardRef<HTMLDivElement, DataCollectionMethodProps>(({
  loading = false,
  isSchemaDrawerOpen,
  openSchemaModal,
  openSchemaDrawer,
  closeAllModals,
  alreadyConfiguredSourceIds = [],
  forceReset = false,
  connectionDraftKey = 0,
}, ref) => {
  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-3">
          <div className="shrink-0 p-2 rounded-lg bg-primaryExtremeLightColor mt-0.5">
            <DatabaseZap className="w-6 h-6 text-primaryColor" />
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-0.5">Step 1</p>
            <h2 className="text-xl font-bold text-gray-900 leading-tight">Data Collection Method</h2>
            <p className="text-sm text-gray-500 mt-1">Connect a revenue data source to power your intelligence dashboard.</p>
          </div>
        </div>
        <button
          onClick={openSchemaDrawer}
          className="shrink-0 text-blue-600 hover:text-blue-800 underline hover:underline-offset-2 bg-transparent px-0 py-0 text-sm font-medium transition-colors flex items-center gap-1 mt-1"
        >
          <Database className="w-4 h-4" />
          <span>Dev Guide: ER Diagram</span>
        </button>
      </div>

      {loading ? (
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">Loading...</div>
        </div>
      ) : (
        <div className="p-6">
          <DataSourceDemoFlow
            key={connectionDraftKey}
            alreadyConfiguredSourceIds={alreadyConfiguredSourceIds}
            forceReset={forceReset}
          />
        </div>
      )}

      <SchemaDrawer
        isOpen={isSchemaDrawerOpen}
        onClose={closeAllModals}
        onOpenSchemaModal={openSchemaModal}
      />
    </div>
  );
})

export default DataCollectionMethod
